import React, { MouseEvent } from "react";
import { AxiosResponse, AxiosError } from "axios";
import DataGrid, { Pager, Paging, FilterRow, Column, Export, SearchPanel, Selection } from "devextreme-react/data-grid";
import gridUtils from "../grid/GridUtilities";
import PaymentService, { PaymentGridRowItem, paymentStatus } from "../../services/PaymentService";
import paymentActionCell from "../Payments/PaymentActionCellComponent";
import UserService, { RoleGroupNames } from "../../services/UserService";
import { onExportingEvent } from "../../types/DevExtremeTypes";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import InvoiceAmountCell from "../Payments/ProviderPayment/InvoiceAmountCellComponent";
import STAInvoicePayment from "../Payments/ProviderPayment/STAInvoicePayment";
import sharedUtils from "../grid/sharedUtilities";
import { Link } from "react-router-dom";
import { closeDrawer } from "../header/NavigationUtils";
import { saveAs } from "file-saver";
import { LoadIndicator, Popup, ScrollView } from "devextreme-react";
import SimpleShiftsByService from "../SimpleShiftsByService/SimpleShiftsByService";
interface NewAccountsPaymentsGridProps {
    id: string;
    paymentsRefresh: boolean;
    onSendToAccounts: (status: string, statusId: string, isRestartDisable: boolean) => void;
    updateErrMessage: () => void;
    statusId: string;
    gridErrorMsg: [];
}
interface NewAccountsPaymentsGridState {
    gridDataSource: PaymentGridRowItem[];
    showProgressIndicator: boolean;
    CalculationsObject: {
        subTotal: string;
        total: string;
        tax: string;
    };
    checkSquareIconVisible: boolean;
    simpleShiftPopupVisible: boolean;
    serviceId: string;
    paymentId: string;
    simpleShiftPopupVisibleData: any[];
}

class NewAccountsPaymentsGrid extends React.Component<NewAccountsPaymentsGridProps, NewAccountsPaymentsGridState> {
    state: NewAccountsPaymentsGridState;
    //Initialize the service to fetch the data.
    Service: PaymentService;
    //Reuse the Grid utils component to format the cells.
    gridUtils: gridUtils;
    sharedUtils: sharedUtils;
    userHasAccess: boolean;

    constructor(props: NewAccountsPaymentsGridProps) {
        super(props);
        // Initialize state and services/utils
        this.Service = new PaymentService();
        this.gridUtils = new gridUtils();
        this.sharedUtils = new sharedUtils();
        this.userHasAccess =
            UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager) ||
            UserService.isUserInGroup(RoleGroupNames.EventUKRelationshipManager);
        this.state = {
            gridDataSource: [],
            showProgressIndicator: false,
            CalculationsObject: {
                subTotal: "",
                total: "",
                tax: "",
            },
            checkSquareIconVisible: false,
            simpleShiftPopupVisible: false,
            serviceId: "",
            paymentId: "",
            simpleShiftPopupVisibleData: [],
        };
        this.updateGridDataSource = this.updateGridDataSource.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleError = this.handleError.bind(this);
    }

    componentDidMount() {
        this.updateGridDataSource();
    }

    componentDidUpdate(prevprops: NewAccountsPaymentsGridProps) {
        if (this.props.paymentsRefresh != prevprops.paymentsRefresh) {
            this.updateGridDataSource();
        }
    }

    onExporting = (e: onExportingEvent) => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            //topLeftCell: { row: 2, column: 2 },
            customizeCell: ({ gridCell, excelCell }) => {
                if (gridCell && gridCell.rowType === "data") {
                    if (
                        gridCell.column &&
                        (gridCell.column.dataField === "subAmount" ||
                            gridCell.column.dataField === "tax" ||
                            gridCell.column.dataField === "amount" ||
                            gridCell.column.dataField === "lastPayment" ||
                            gridCell.column.dataField === "varience")
                    ) {
                        excelCell.value = parseFloat(gridCell.value);
                        excelCell.numFmt = "£#,##0.00";
                    }
                }
            },
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DataGrid.xlsx");
            });
        });
        e.cancel = true;
    };

    // Fire parent component's callback with data from grid
    updateGridDataSource() {
        if (this.userHasAccess) {
            this.setState({
                showProgressIndicator: true,
            });
            this.Service.getPaymentGridRowItems(this.props.id).then(this.handleSuccess).catch(this.handleError);
        }
    }

    handleSuccess(response: AxiosResponse<any>) {
        // Modify the response data to include the `staStatus` field
        const modifiedData = response.data.data.map((item: any) => ({
            ...item,
            staStatus: item.sentToAccountsDateInvoice && item.sentToAccountsDatePayment ? "success" : "failure",
        }));
        const allSuccess = modifiedData.every((item: any) => item.staStatus === "success");
        this.setState({ gridDataSource: modifiedData, showProgressIndicator: false }, () => {
            if (this.props.gridErrorMsg) {
                this.props.gridErrorMsg.map((item: any) => {
                    const parts = item.errorMessage.split("~").filter(Boolean);
                    const id = parts[0];
                    const errMsg = parts[1];
                    this.setState((prevState) => ({
                        gridDataSource: prevState.gridDataSource.map((item) =>
                            item.paymentId == id ? { ...item, error: errMsg } : item
                        ),
                    }));
                });
            }
            if (allSuccess) {
                this.props.onSendToAccounts(
                    this.props.statusId >= "45" ? this.props.statusId : paymentStatus.SendToAccounts,
                    this.props.statusId >= "45" ? this.props.statusId : paymentStatus.SendToAccounts,
                    false
                );
                this.props.updateErrMessage();
            }
        });
    }

    handleError(error: AxiosError<any>) {
        this.setState({
            showProgressIndicator: false,
        });
        var respMessage: string = "Get payment Grid rows service load failed with response: " + JSON.stringify(error);

        if (!this.Service.traceAsErrorToAppInsights(respMessage)) {
            // AppInsights is not available
            console.error(respMessage);
        }
    }

    setVarianceColour = (cellElement: any, cellInfo: any) => {
        var cellVarianceWithCurrencySymbol = this.sharedUtils.thousandsSeparator(cellInfo.data.varience);
        if (cellInfo.data.rag == "Green" && cellInfo.data.varience) {
            cellElement.classList.add("text-success");
        } else if (cellInfo.data.rag == "Amber" && cellInfo.data.varience) {
            cellElement.classList.add("text-warning");
        }
        if (cellInfo.data.varience) {
            cellElement.append(cellVarianceWithCurrencySymbol);
        }
    };

    DisplaySimpleShiftGrid = (cellInfo: any) => {
        return (
            <div>
                <Link
                    onClick={(e: MouseEvent) => {
                        e.preventDefault();
                        this.showSimpleShiftGrid(cellInfo.data);
                    }}
                    className="approval-query-column top-12px"
                    to="#"
                >
                    {this.sharedUtils.thousandsSeparator(cellInfo.data.subAmount)}
                </Link>
            </div>
        );
    };
    showSimpleShiftGrid = (cellInfo: any) => {
        this.setState(
            {
                simpleShiftPopupVisible: true,
                serviceId: cellInfo.serviceId,
                paymentId: cellInfo.paymentId,
            },
            () => {
                closeDrawer();
            }
        );
    };
    hideSimpleShiftGrid = () => {
        this.setState({
            simpleShiftPopupVisible: false,
        });
    };
    setCalculations = () => {};

    onRefresh = (isRefresh: boolean) => {
        if (isRefresh) {
            this.updateGridDataSource();
        }
    };

    InvoiceAmountCell = (cellInfo: any) => {
        return (
            <>
                <InvoiceAmountCell data={cellInfo} onRefresh={this.onRefresh} />
            </>
        );
    };
    StaCallInvoice = (cellInfo: any) => {
        return (
            <>
                <STAInvoicePayment
                    data={cellInfo}
                    onRefresh={this.updateGridDataSource}
                    type={"invoice"}
                    handleErr={this.handleErr}
                    handleSuccessStaCall={this.handleSuccessStaCall}
                />
            </>
        );
    };
    StaCallPayment = (cellInfo: any) => {
        return (
            <>
                <STAInvoicePayment
                    data={cellInfo}
                    onRefresh={this.updateGridDataSource}
                    type={"payment"}
                    handleErr={this.handleErr}
                    handleSuccessStaCall={this.handleSuccessStaCall}
                />
            </>
        );
    };
    handleSuccessStaCall = (respMessage:any)=>{
        const id = respMessage.paymentId;
        const sentToAccountsDateInvoice = respMessage.sentToAccountsDateInvoice?respMessage.sentToAccountsDateInvoice.split(" ")[0]:"";
        const sentToAccountsDatePayment  = respMessage.sentToAccountsDatePayment?respMessage.sentToAccountsDatePayment.split(" ")[0]:"";
        this.setState((prevState) => ({
            gridDataSource: prevState.gridDataSource.map((item) =>
                item.paymentId == id ? { ...item, sentToAccountsDateInvoice:sentToAccountsDateInvoice,sentToAccountsDatePayment:sentToAccountsDatePayment } : item
            ),
        }));
    }
    handleErr = (respMessage: string) => {
        const parts = respMessage.split("~").filter(Boolean); // removes empty strings
        const id = parts[0]; // "4916"
        const errMsg = parts[1]; // full message
        this.setState((prevState) => ({
            gridDataSource: prevState.gridDataSource.map((item) =>
                item.paymentId == id ? { ...item, error: errMsg } : item
            ),
        }));
    };
    renderErrorCell = (cellInfo: any) => {
        if (!cellInfo.data.error) return null;

        return (
            <div
                style={{
                    color: "red",
                    whiteSpace: "normal", // allow wrapping
                    wordBreak: "break-word", // break long words
                    lineHeight: "1.4",
                    padding: "4px 0",
                }}
            >
                {cellInfo.data.error}
            </div>
        );
    };

    render() {
        return (
            <div>
                <h4 className="ml-3 font-weight-bold"></h4>
                {this.state.showProgressIndicator ? (
                    <div className="starter-template">
                        <LoadIndicator
                            id="simple-grid-indicator"
                            height={50}
                            width={50}
                            visible={this.state.showProgressIndicator}
                        />
                    </div>
                ) : (
                    <DataGrid
                        dataSource={this.state.gridDataSource}
                        showBorders={false}
                        showColumnLines={false}
                        hoverStateEnabled={true}
                        columnAutoWidth={true}
                        allowColumnResizing={true}
                        columnResizingMode={"widget"}
                        onExporting={this.onExporting}
                        wordWrapEnabled={true}
                    >
                        <Export enabled={true} />
                        <SearchPanel visible={true} placeholder={"Search"} />
                        <Paging defaultPageSize={10} />
                        <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20]} showInfo={true} />
                        <Column dataField="paymentId" caption="ID" />
                        <Column
                            dataField="sentToAccountsDateInvoice"
                            caption="INVOICE STA DATE"
                            cellRender={this.StaCallInvoice}
                            width={140}
                        />
                        <Column
                            dataField="sentToAccountsDatePayment"
                            caption="PAYMENT STA DATE"
                            cellRender={this.StaCallPayment}
                            width={140}
                        />
                        <Column dataField="staStatus" caption="STATUS" />
                        <Column dataField="error" caption="ERROR" cellRender={this.renderErrorCell} width={300} />
                        <Column dataField="entity" caption="PROVIDER" />
                        <Column dataField="entityId" caption="PROVIDER ID" />
                        <Column dataField="serviceValue" caption="SERVICE" />
                        <Column dataField="reference" caption="REFERENCE" />
                        <Column
                            dataField="subAmount"
                            caption="PROVIDER NET"
                            cellRender={this.DisplaySimpleShiftGrid}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.subAmount);
                            }}
                        />
                        <Column
                            dataField="tax"
                            caption="PROVIDER VAT"
                            calculateDisplayValue={(rowData: any) => {
                                return this.sharedUtils.thousandsSeparator(rowData.tax);
                            }}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.tax);
                            }}
                        />
                        <Column
                            dataField="amount"
                            caption="PROVIDER GROSS"
                            cellRender={this.InvoiceAmountCell}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.amount);
                            }}
                        />
                        <Column dataField="sortCode" caption="SORT CODE" />
                        <Column dataField="accountNumber" caption="ACCOUNT #" />
                        <Column dataField="status" caption="STATUS" />
                        <Column dataField="action" caption="ACTION" cellComponent={paymentActionCell} />
                        <Column
                            dataField="payDate"
                            caption="EARLIEST PAY DATE"
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.payDate);
                            }}
                            calculateCellValue={(rowData: any) => {
                                return this.gridUtils.convertddmmyyyyStringToDate(rowData.payDate);
                            }}
                            format="dd/MM/yyyy"
                            dataType="date"
                        />
                        <FilterRow visible={true} applyFilter="auto" />
                    </DataGrid>
                )}
                <Popup
                    visible={this.state.simpleShiftPopupVisible}
                    onHiding={this.hideSimpleShiftGrid}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    showCloseButton={true}
                    title={"Included Shifts"}
                    // width={"90%"}
                    // height={"80%"}
                >
                    <ScrollView width="100%" height="100%">
                        <SimpleShiftsByService
                            clientId=""
                            venueId=""
                            serviceTypeId={this.state.serviceId}
                            startDate=""
                            endDate=""
                            setCalculations={this.setCalculations}
                            paymentId={this.state.paymentId}
                            getBuild={() => {
                                return null;
                            }}
                            simpleShiftPopupVisibleData={
                                this.state.simpleShiftPopupVisibleData ? this.state.simpleShiftPopupVisibleData : []
                            }
                        ></SimpleShiftsByService>
                    </ScrollView>
                </Popup>
            </div>
        );
    }
}
export default NewAccountsPaymentsGrid;
